var _path, _path2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,1H6.8C4.9,1,3.5,2.3,3.5,4v16c0,1.7,1.4,3,3.3,3h12.1c1.9,0,3.3-1.3,3.3-3V4C22.1,2.4,20.7,1,18.8,1z M6.8,3h12.1 c0.7,0,1.1,0.4,1.1,1v3.4H5.7V4C5.7,3.5,6.1,3,6.8,3z M18.8,21H6.8c-0.7,0-1.1-0.4-1.1-1V8.5h14.2v11.6C19.9,20.6,19.5,21,18.8,21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,10.6H8.4c-0.9,0-1.7,0.7-1.7,1.6v6c0,0.9,0.7,1.6,1.7,1.6h8.7c0.9,0,1.7-0.7,1.7-1.6v-6 C18.8,11.4,18.1,10.6,17.2,10.6z M17.7,18.3c0,0.3-0.3,0.5-0.6,0.5H8.4c-0.3,0-0.6-0.2-0.6-0.5v-6c0.1-0.3,0.3-0.6,0.6-0.6h8.7 c0.3,0,0.6,0.2,0.6,0.5V18.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 5.6,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 5.6,
    r: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 5.6,
    r: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForno);
export default __webpack_public_path__ + "static/media/forno.a0716620b43d24be98a97b1001b13f50.svg";
export { ForwardRef as ReactComponent };